module.exports = __webpack_public_path__ + "static/img/3.65f236a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/3.png
// module id = yulO
// module chunks = 0